import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface LaneDetailResponse extends Lane {
  awarded_proposals: LaneProposal[]
}

interface State {
  detail: {
    lane?: Lane
    meta: {
      error: string | null
      isLoading: boolean
    }
  }
}

const initialState: State = {
  detail: {
    meta: {
      error: null,
      isLoading: false,
    },
  },
}

export const slice = createSlice({
  name: 'laneDetail',
  initialState,
  reducers: {
    fetchLaneDetailStart(state) {
      state.detail.meta.isLoading = true
    },
    fetchLaneDetailSuccess(state, action: PayloadAction<LaneDetailResponse>) {
      const awarded_proposals = action.payload.awarded_proposals.reduce(
        (acc: Record<number, LaneProposal>, curr: LaneProposal) => {
          acc[curr.id] = curr
          return acc
        },
        {}
      )
      state.detail.lane = {
        ...action.payload,
        awarded_proposals,
      }
      state.detail.meta.isLoading = false
    },
    fetchLaneDetailFailed(state, action: PayloadAction<string>) {
      state.detail.meta.error = action.payload
      state.detail.meta.isLoading = false
    },
  },
})

export default slice.reducer
